import { useQuery } from '@tanstack/react-query';
import { DriveRequests } from 'src/requests/drive';
import { queryRetry } from 'src/utils/react-query';

export const useDriveAncestorsQuery = (contentId?: string) => {
  const queryKey = ['Drive-ancestors', contentId];
  const { data: driveAncestors, isLoading } = useQuery(
    queryKey,
    () => DriveRequests.getContentAncestors(contentId!),
    {
      enabled: !!contentId,
      keepPreviousData: true,
      retry: queryRetry,
    },
  );
  return {
    driveAncestors,
    isDriveAncestorsLoading: isLoading,
  };
};
